<div *ngFor="let setup of relatedQuestionSetups" class="section-area">
    <span class="section-title">
        {{setup.EmployeeReviewQuestionSetupLevelIdDisplay}} Questions

        <ng-container *ngIf="setup.EmployeeReviewQuestionSetupLevelId == 2">
            for {{setup.WachterDepartmentIdDisplay}}

            <i class="fa fa-info-circle" title="These questions are shared for all teams in this department."></i>
        </ng-container>
        <ng-container *ngIf="setup.EmployeeReviewQuestionSetupLevelId == 1">
            <i class="fa fa-info-circle"
                title="These questions are set my Human Resource for all departments & Teams"></i>
        </ng-container>
    </span>

    <ng-container *ngIf="setup.EmployeeReviewQuestionSetupLevelId == 2 && false">
        <div dwRow>
            <div dwCol="6">
                <label class="label">Hide Revenue Questions</label>
                <dw-readonly [(ngModel)]="setup.HideRevenueQuestions" format="yesno"></dw-readonly>
            </div>
            <div dwCol="6">
                <label class="label">Hide Bidding Questions</label>
                <dw-readonly [(ngModel)]="setup.HideBiddingQuestions" format="yesno"></dw-readonly>
            </div>
        </div>


    </ng-container>

    <div *ngFor="let detail of setup.EmployeeReviewQuestionSetupDetail" class="section-detail">
        {{detail.EmployeeReviewQuestion?.Question}}
    </div>

    <div *ngIf="setup.EmployeeReviewQuestionSetupDetail.length == 0">
        There are no custom questions at this level
    </div>

    <div dwRow *ngIf="setup.EmployeeReviewQuestionSetupLevelId == 2">
        <div dwCol="12">
            <div class="dw-chip-container">
                <div *ngIf="setup.HideRevenueQuestions" class="dw-chip" title="Revenue questions have been hidden for this department">
                    <div class="dw-chip dw-chip-100">
                        <div class="dw-chip-label"><i class="fa fa-sack-dollar"></i> Hide Revenue Questions</div>
                    </div>
                </div>
                <div *ngIf="setup.HideBiddingQuestions" class="dw-chip" title="Bidding questions have been hidden for this department">
                    <div class="dw-chip dw-chip-100">
                        <div class="dw-chip-label"><i class="fa fa-money-check-edit"></i> Hide Bidding Questions</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="section-area2">
    <span class="section-title">
        {{ currentQuestionsDisplay }} Questions
    </span>

    <div dwRow [formGroup]="formGroup" *ngIf="!hideRevenueQuestion || !hideBiddingQuestion">
        <div dwCol="6" *ngIf="!hideRevenueQuestion">
            <label class="label">Hide Revenue Questions</label>
            <dw-yesno formControlName="HideRevenueQuestions"></dw-yesno>
        </div>
        <div dwCol="6" *ngIf="!hideBiddingQuestion">
            <label class="label">Hide Bidding Questions</label>
            <dw-yesno formControlName="HideBiddingQuestions"></dw-yesno>
        </div>
    </div>
</div>